import React from "react";
import PageLayout from "../../../components/Layout/PageLayout";
import CaseStudy from "./misc/CaseStudy";

const CaseStudyScreen: React.FC = () => {
  return (
    <PageLayout>
      <CaseStudy />
    </PageLayout>
  );
};

export default CaseStudyScreen;
